import React, {useEffect, useState} from "react";

import TableIndicator from "components/TableIndicator";
// import {SelectIndicator} from "components/Select";

import {useUser} from "store/providers/app";

// import {getIndicators} from "services/Indicators.service";
// import TableFilterTags from "components/TableIndicator/tableFilterTags";
//import {getTags} from "services/Tags.service";
//import Select from "react-select";
import {rulesProfileDashboard} from "../../../../utils/rulesContent";

export const IndicatorsList = ({selected, year_reference}) => {

    const { user } = useUser()

    // const [selectedTag, setSelectedTag] = useState(null);
    // const [tagName, setTagName] = useState('');
    // const [dataTag, setDataTag] = useState([]);
    // const [loadingTags, setLoadingTags] = useState(false)

    // useEffect(() => {
    //
    //     const Request = async () => {
    //         if (selectedTag) {
    //             setLoadingTags(true)
    //             const response = await getTags(selectedTag)
    //             setDataTag(response)
    //         } else {
    //             setDataTag([])
    //             setTagName('')
    //         }
    //     }
    //
    //     Request().then(r => setLoadingTags(false))
    //
    // },[selectedTag])

    return (
        <>
            <div className="card mt-3 shadow-sm border-0">
                { user.profile === 7 &&
                    <div className="row justify-content-end px-1">
                        <div className="col-4 p-2">
                            {/*<Select setSelected={setSelectedTag}/>*/}
                        </div>
                        <div className="col-4 p-2">
                            {/*<select className="form-select" onChange={(e) => setTagName(e.target.value)}>*/}
                            {/*    {loadingTags ?*/}
                            {/*        <option>Buscando... </option> : !loadingTags && dataTag.length === 0 &&*/}
                            {/*        <option> Selecione uma tag</option>}*/}
                            {/*    {dataTag?.map((tag, index) => (*/}
                            {/*        <option key={index} value={tag.name}>{tag.name}</option>*/}
                            {/*    ))}*/}
                            {/*</select>*/}
                        </div>
                    </div>
                }
            </div>

            { selected && user.profile !== 7 ?
                <TableIndicator
                    selected={selected.title}
                    status={selected.status}
                    language={selected.language}
                    year_reference={year_reference}
                />
            :
            rulesProfileDashboard.map((item,index) => {
                const authUser = item.rules.includes(user.profile)
                if (!authUser) return <></>

                return (
                    <React.Fragment key={item.status}>
                        { index > 1 && item.language !== rulesProfileDashboard[index-1].language && <br />}
                        <TableIndicator status={item.status} language={item.language} title={item.title} year_reference={year_reference} />
                    </React.Fragment>
                )
            })}

            { user.profile === 1 && !selected && (
                <div className="mt-5">
                    <TableIndicator trashed={true} />
                </div>
            )}
        </>
    );
}

